<template>
  <b-overlay :show="formShow" rounded="sm" no-fade class="mt-1">
    <b-card>
      <b-row class="mb-1">
        <b-col
          cols="12"
          md="7"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button
            variant="outline-primary"
            class="btn-icon"
            @click="$router.go(-1)"
          >
            <i class="fa-solid fa-arrow-left"></i>
            <span class="ml-25">Back</span>
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col" v-if="pillarId > 0">Pillar Edit</th>
              <th scope="col" v-else>Pillar Add</th>
            </tr>
          </thead>
        </table>
      </b-row>

      <validation-observer ref="pillarRules">
        <b-form>
          <b-row>
            <b-col cols="1">
              <b-form-group label="Order Number" label-for="order">
                <validation-provider name="order" #default="{ errors }">
                  <b-form-input
                    id="title"
                    type="number"
                    v-model.number="pillarValue.order"
                    @change="checkOrderNumber"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group label="Title" label-for="title">
                <validation-provider
                  name="title"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-input
                    id="title"
                    type="text"
                    v-model="pillarValue.title"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" class="mt-1">
              <b-form-group label="Pillar Colour" label-for="color">
                <app-color-palette-vue
                  v-if="!formShow"
                  @update:selected-color="colorSelectedHandler"
                  :row-number="16"
                  :selected-color-data="pillarValue.color.textColor"
                  :selected-bg-color-data="pillarValue.color.bgColor"
                ></app-color-palette-vue>
              </b-form-group>
            </b-col>
          </b-row>

          <hr />

          <b-row>
            <b-col cols="12">
              <b-button
                v-if="pillarId == null"
                type="submit"
                @click.prevent="formSubmitted"
                variant="primary"
                class="float-right"
              >
                Save
              </b-button>
              <b-button
                v-else
                type="submit"
                @click.prevent="formSubmitted"
                variant="primary"
                class="float-right"
              >
                Save Changes
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>
<script>
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "../settingsStoreModule";
import vSelect from "vue-select";
import router from "@/router";
import AppColorPaletteVue from "@/@core/layouts/components/AppColorPalette.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";

export default {
  components: {
    vSelect,
    ToastificationContent,
    AppColorPaletteVue,
    ValidationProvider,
    ValidationObserver,
  },

  setup() {
    const OBJECT_CODE_APP_STORE_MODULE_NAME = "settings";
    // Register module
    if (!store.hasModule(OBJECT_CODE_APP_STORE_MODULE_NAME))
      store.registerModule(
        OBJECT_CODE_APP_STORE_MODULE_NAME,
        settingsStoreModule
      );

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(OBJECT_CODE_APP_STORE_MODULE_NAME))
        store.unregisterModule(OBJECT_CODE_APP_STORE_MODULE_NAME);
    });
  },

  data() {
    return {
      pillarValue: {
        title: "",
        order: null,
        color: "",
        required,
        email,
      },
      formShow: false,
      pillarId: null,
    };
  },

  watch: {},

  mounted() {
    this.getPillarById();
  },

  methods: {
    getPillarById() {
      if (router.currentRoute.params.id) {
        this.formShow = true;
        this.pillarId = parseInt(router.currentRoute.params.id);

        store
          .dispatch("settings/getPillarById", {
            id: router.currentRoute.params.id,
          })
          .then((res) => {
            this.pillarValue = res.data;
            this.pillarValue.color = {
              textColor: "#000",
              bgColor: res.data.color,
            };
            this.formShow = false;
          })
          .catch((error) => {
            console.log(error);
            this.formShow = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "An error occurred",
                text: "Please try again later or contact support.",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          });
      }
    },

    checkOrderNumber() {
      store
        .dispatch("settings/checkOrderNumber", this.pillarValue.order)
        .then((res) => {
          if (res.data.existing) {
            const existingOrders = res.data.existingOrders;

            let newOrder = 1;
            while (existingOrders.includes(newOrder)) {
              newOrder++;
            }

            // Assign the first available number
            this.pillarValue.order = newOrder;
          }
        });
    },

    colorSelectedHandler(textColor, bgColor) {
      this.pillarValue.color = {
        textColor: textColor,
        bgColor: bgColor,
      };
    },

    formSubmitted() {
      this.formShow = true;
      if (!this.pillarValue.color.bgColor) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text: "Please select a color in the color palette.",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        this.formShow = false;
        return;
      }

      this.$refs.pillarRules.validate().then((success) => {
        if (success) {
          if (this.pillarId == null) {
            store
              .dispatch("settings/savePillar", this.pillarValue)
              .then((response) => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Successful",
                    text: "✔️ Pillar Add Successful",
                    icon: "ThumbsUpIcon",
                    variant: "success",
                  },
                });

                router.push({ name: "settings-pillars" });
              })
              .catch((error) => {
                this.formShow = false;
                console.log(error);
                const errorMessage =
                  error.response?.data?.errors?.title?.[0] ||
                  "An error occurred while saving the pillar.";
                this.handleError(errorMessage);
              });
          } else {
            store
              .dispatch("settings/updatePillar", this.pillarValue)
              .then((response) => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Successful",
                    text: "✔️ Pillar Update Successful",
                    icon: "ThumbsUpIcon",
                    variant: "success",
                  },
                });

                router.push({ name: "settings-pillars" });
              })
              .catch((error) => {
                this.formShow = false;
                console.log(error);
                const errorMessage =
                  error.response?.data?.errors?.title?.[0] ||
                  "An error occurred while saving the pillar.";
                this.handleError(errorMessage);
              });
          }
        } else {
          this.formShow = false;
        }
      });
    },

    handleError(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: message,
          icon: "AlertCircleIcon",
          variant: "danger",
        },
      });
      this.formShow = false;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
